export default __webpack_public_path__ + "media/images/temporary/wholesale-hero-bc7eba3316bad361a54a88b1d132f851.jpg";